export default "__VITE_PUBLIC_ASSET__7f46f5c3__"